<template>
  <div class="overzicht-tokens">
    <table cellspacing="0">
      <thead>
        <tr>
          <th>Naam</th>
          <th>Laatste gebruikt</th>
          <th>Status</th>
          <th>Acties</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="t in tokens" :key="t.Id">
          <td class="col">{{t.Naam}}</td>
          <td class="col">{{t.LaatstGebruikt}}</td>
          <td class="col">{{t.Status}}</td>
          <td class="col"><button @click="reset(t)">Reset</button></td>
        </tr>
      </tbody>
    </table>
    <v-btn @click="getTokens()" color="primary">Refresh</v-btn>
  </div>
</template>


<script>
export default {
  name: "overzichttokens",
  components: {},
  data() {
    return {
      tokens: []
    };
  },
  methods: {
    getTokens: function() {
      this.$api.pOverzichtTokens().then(response => {
        this.tokens = response.data;
      });
    },
    reset: function(token) {
        this.$api.pResetToken({TokenId: token.Id}).then(() => {
            this.getTokens();
            alert('Token "'+token.Naam+'" is gereset.');
          });
    }
  },
  created: function() {
    this.getTokens();
  }
};
</script>


<style scoped>
table {
  width: 100%;
  margin-bottom: 15px;
  border: 1px solid silver;
}

.rapport-sessie {
  margin-top: 10px;
  margin-bottom: 20px;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

tr,
td {
  border-width: 0px;
}



thead {
  background-color: #00b4d1;
  color: #fff;
}

th {
    text-align: left;
}
</style>
